const API_URL = import.meta.env.VITE_API_URL

export const fetchWithAuth = async (endpoint, options = {}) => {
    const adminUser = JSON.parse(sessionStorage.getItem('adminUser') || '{}')

    const headers = {
        'Content-Type': 'application/json',
        ...options.headers
    }

    const response = await fetch(`${API_URL}${endpoint}`, {
        ...options,
        headers
    })

    if (response.status === 401) {
        // Session expired or invalid
        sessionStorage.removeItem('adminUser')
        window.location.href = '/admin/login'
        throw new Error('Session expired')
    }

    const data = await response.json()

    if (!response.ok) {
        throw new Error(data.error || 'Something went wrong')
    }

    return data
}

export const logout = () => {
    sessionStorage.removeItem('adminUser')
    window.location.href = '/admin/login'
} 